import { useAppSelector } from '@/store';
import { selectCurrentMerchantFeatures } from '@/store/slices/authSlice';
import { usePermission } from '@/hooks/usePermission';

interface UseFeaturePermissionArgs {
    permission: string | string[];
    featureKey?: string;
}

/**
 * Unified access check:
 * - Parent gate: merchant feature flag (if provided)
 * - Child gate: user permission(s)
 *
 * Backward compatibility:
 * If a feature key is missing from merchant.features, treat it as enabled.
 */
export const useFeaturePermission = ({
    permission,
    featureKey,
}: UseFeaturePermissionArgs) => {
    const features = useAppSelector(selectCurrentMerchantFeatures);
    const hasPermission = usePermission(permission);

    const isFeatureEnabled = featureKey ? features[featureKey] !== false : true;
    const hasAccess = isFeatureEnabled && hasPermission;

    return {
        hasAccess,
        hasPermission,
        isFeatureEnabled,
    };
};

export default useFeaturePermission;
